import { useTranslation } from "react-i18next";
import { Stack, Typography } from "@mui/material";
import { EAppointmentType } from "@constants";

interface IParams {
    isPreOrder?: boolean;
    appointmentType?: EAppointmentType;
}

export const InstallationEquipment = (props: IParams) => {
    const { isPreOrder, appointmentType } = props;
    const { t } = useTranslation("installation");

    return (
        <Stack spacing={1}>
            {!isPreOrder && appointmentType === EAppointmentType.NO_INSTALL ? (
                <>
                    <Typography color="secondary" gutterBottom variant="normal">
                        {t("noInstallEquipment")}
                    </Typography>
                    <Typography color="secondary" gutterBottom variant="normal">
                        {t("defaultEquipmentArriveSeparately")}
                    </Typography>
                </>
            ) : (
                <>
                    <Typography color="secondary" gutterBottom variant="normal">
                        {t("defaultEquipmentTechnician")}
                    </Typography>
                    <Typography color="secondary" gutterBottom variant="normal">
                        {t("defaultEquipmentArriveSeparately")}
                    </Typography>
                </>
            )}
        </Stack>
    );
};
